import { TokenRefresher } from "../authentication/AuthAPI";

class DefaultTokenRefresher implements TokenRefresher {
  refreshToken(): Promise<boolean> {
    return new Promise((resolve, _) => resolve(false))
  }
}

export { DefaultTokenRefresher }